import TableStateModel from "../../../features/shared/models/TableStateModel";

export enum MainActionTypes {
  SET_TABLE_STATE = "@@contracts/GET_CONTRACTS",
}

export type MainAction = {
  type: MainActionTypes.SET_TABLE_STATE;
  data: TableStateModel;
};
